import Navigation from './bottom-navigation';
import styled from 'styled-components';
import { Sidebar } from 'modules/components/common';
import { Navbar } from 'modules/components/common/navbar';

const AppLayout = (props) => {
  return (
    <StyledWebLayout>
      <div className="root-layout">
        <div>
          <Navbar />
          {props.children}
        </div>

        <Sidebar />
      </div>
      <div className="mobile-navigation">
        <Navigation />
      </div>
    </StyledWebLayout>
  );
};

export default AppLayout;

const StyledWebLayout = styled.main`
  .root-layout {
    padding: 0 0 72px;
  }

  @media screen and (min-width: 1024px) {
    overflow: hidden;
    .mobile-navigation {
      display: none;
    }
    .root-layout {
      width: 100%;
      display: grid;
      /* gap: 9px; */
      position: relative;
      padding: 38px 32px 0;
      grid-template-columns: calc(100% - 169px) 160px;
      max-width: 1024px;
      margin: auto;
    }
  }
`;
